import React from 'react';
import { MENTION_SPLIT_REGEX, getMentionName } from '../utils/mentions';

interface FormattedTextProps {
  text: string;
  mentionClassName?: string;
}

const FormattedText: React.FC<FormattedTextProps> = ({ 
  text, 
  mentionClassName = "text-parliament-600 dark:text-parliament-400 font-bold" 
}) => {
  if (!text) return null;

  const parts = text.split(MENTION_SPLIT_REGEX);

  return (
    <>
      {parts.map((part, i) => {
        const name = getMentionName(part);
        if (name) {
          return (
            <span key={i} className={mentionClassName}>
              @{name}
            </span>
          );
        }
        return part;
      })}
    </>
  );
};

export default FormattedText;